import React from "react";
import "./ProjectContent.css";
import "./ArtContent.css";
import CapurganaIsland from "../../../assets/projects/Art/CapurganaIsland.png";
import AmazonianWarrior_one from "../../../assets/projects/Art/AmazonianWarrior_one.png";
import AmazonianWarrior_two from "../../../assets/projects/Art/AmazonianWarrior_Two.png";
import CoffeeShop_Main from "../../../assets/projects/Art/LaOrange.png";
import CoffeeShop_Two from "../../../assets/projects/Art/LaOrange_two.png";
import Geotermia_Personaje_One from "../../../assets/projects/Art/Geotermia_personajes_two.png";
import Geotermia_Personaje_Two from "../../../assets/projects/Art/Geotermia_personaje_one.png";
import Modelling_one from "../../../assets/projects/Art/3dModelling_one.png";
import Modelling_two from "../../../assets/projects/Art/3dModelling_two.png";

export default function ArtContent() {
  return (
    <div className="art-content">
      {/* Intro Text */}
      <div className="art-intro">
        <p>
          In moments when I wasn't under the urgent need to survive, I would often contemplate the details of the space and the corners I'd always inhabited but hadn't truly noticed. It was in those brief moments that I liked to sit and imagine worlds, to dream, to draw, to think, to let my mind wander...
        </p>
      </div>

      {/* Capurganá's Island Section */}
      <div className="art-section">
        <h2 className="art-section-title">Capurganá's Island</h2>
        <p className="art-section-description">
       Capurgana is a small island in the pacific coast of Colombia. It is small but it is full of people with kindness, beautiful beaches and sunsets. This is my favorite place and I wanted to capture the beauty of this place in an scenarie concept.
        </p>
      
        <img src={CapurganaIsland} alt="Capurganá's Island illustration" />
      </div>

      {/* Amazonian Warrior Section */}
      <div className="art-section">
        <h2 className="art-section-title">Amazonian warrior</h2>
        <p className="art-section-description">
          Following the study of video game characters, I designed a character based on an Amazonian warrior whose main weapon is the bow and whose values ​​are determination, strength, velocity, and precision.
        </p>
        <div className="art-image-grid">
          <img
            src={AmazonianWarrior_one}
            alt="Amazonian Warrior illustration 1"
          />
          <img
            src={AmazonianWarrior_two}
            alt="Amazonian Warrior illustration 2"
          />
        </div>
      </div>

      {/* Coffee Shop Section */}
      <div className="art-section">
        <h2 className="art-section-title">Coffee shop "Le orange"</h2>
        <p className="art-section-description">
         After watching Luca Guadagnino's film "Call Me By Your Name," I fell in love with the Italian landscapes and atmosphere. The concept for this café, called "Le Orange," is inspired by its surroundings, including the streets, cities, summer, and orange trees.
        </p>
        <div className="art-image-grid">
          <img
            src={CoffeeShop_Main}
            alt="La Orange coffee shop illustration 1"
          />
          <img
            src={CoffeeShop_Two}
            alt="La Orange coffee shop illustration 2"
          />
        </div>
      </div>

      {/* Character Design Section */}
      <div className="art-section">
        <h2 className="art-section-title">
          Character design for an audiovisual project
        </h2>

        <p className="art-section-description">
         I participated as a character designer for a series of educational videos aimed at promoting the benefits of geothermal energy and its applications. This was the result of a thesis project by two students from Universidad de Medellín.
        </p>
        <button className="buttonLink"
          onClick={() =>
            window.open(
              "https://www.ageocol.org/serie-educativa-de-videos-en-formato-comics-kutani-y-la-mision-geotermica",
              "_blank"
            )
          }
        >
          Watch publication  <span className="buttonLinkSpanIcon">➞</span>
        </button>
        <div className="art-image-grid">
          <img
            src={Geotermia_Personaje_One}
            alt="Geotermia character design 1"
          />
              <p className="art-section-description">
          Ktiani, the main character, represents geothermal energy, which is
          obtained from the Earth's heat. The character's design incorporates
          significant elements of this theme: the earth (head), which houses the
          energy; the lava (hair), representing the heat emanating from within;
          and the suit, reflecting the industrial process and safety precautions
          required.
        </p>
          <img
            src={Geotermia_Personaje_Two}
            alt="Geotermia character design 2"
          />
        </div>
      </div>

      {/* 3D Art Divider */}
      <div className="art-divider">3D art</div>

      {/* 3D Modeling Section 1 */}
      <div className="art-section">
        <h2 className="art-section-title">The cute ogre</h2>
        <p className="art-section-description">
          Character modeled and
          rendered in ZBrush.
        </p>
        <img src={Modelling_one} alt="3D modeling render 1" />
          <p className="art-section-description-footer">
Image of the 3D render of this character.
The original character design belongs to another artist and was found online.
        </p>
      </div>

      {/* 3D Modeling Section 2 */}
      <div className="art-section">
        <h2 className="art-section-title">Joker sculpture</h2>
        <p className="art-section-description">
          Character modeled and rendered in ZBrush.
        </p>
        <img src={Modelling_two} alt="3D modeling render 2" />
          <p className="art-section-description-footer">
        Image of the 3D render of this character.
The original character design belongs to another artist and was found online.
        </p>
      </div>
    </div>
  );
}
